import { styled } from '@mui/system'
import { BORDER_RADIUSES, colors } from '../../../Constants/consts'
import type { OpenProps } from '../navbar.types'

export const NavToggleStyle = styled('button')<OpenProps>(({ open }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  gap: 5,
  width: 40,
  height: 40,
  padding: 8,
  background: 'transparent',
  border: 'none',
  cursor: 'pointer',
  borderRadius: BORDER_RADIUSES.xSmall,
  transition: 'background-color 0.15s ease',
  '&:focus': {
    outline: 'none',
  },
  '&:focus-visible': {
    outline: `2px solid ${colors.yellow}`,
    outlineOffset: 2,
  },
  '& span': {
    display: 'block',
    height: 2,
    width: 22,
    background: open ? colors.yellow : colors.white,
    borderRadius: 2,
    transition: 'transform 0.3s cubic-bezier(0.4,0,0.2,1), opacity 0.3s ease, background-color 0.15s ease',
    transformOrigin: 'center',
    '&:first-of-type': {
      transform: open ? 'translateY(7px) rotate(45deg)' : 'none',
    },
    '&:nth-of-type(2)': {
      opacity: open ? 0 : 1,
      transform: open ? 'scaleX(0)' : 'scaleX(1)',
    },
    '&:nth-of-type(3)': {
      transform: open ? 'translateY(-7px) rotate(-45deg)' : 'none',
    },
  },
}))
